export const  baseUrl = {
     url : 'https://mobile.singlepointgroup.com/api',
    //  url :'http://localhost:8000'
    // url : "http://20.96.176.202/api"
}

const url = 'https://mobile.singlepointgroup.com/api/auth/user/login';
const local = 'http://localhost:8000'